import SidebarBrand from "@/components/SidebarBrand/SidebarBrand.vue";
import SidebarUserFooter from "@/components/SidebarUserFooter/SidebarUserFooter.vue";
import PlatformSwitcher from "@/components/PlatformSwitcher/PlatformSwitcher.vue";

export default {
  name: "SidebarShell",

  components: {
    SidebarBrand,
    SidebarUserFooter,
    PlatformSwitcher
  },

  props: {
    logo: {
      type: String,
      required: true
    },
    brand_title: {
      type: String,
      default: "Enter Brand Name"
    },
    brand_subtitle: {
      type: String,
      default: "Enter Brand Subtitle"
    },
    initials: {
      type: String,
      default: "GU"
    },
    full_name: {
      type: String,
      default: "Guest User"
    }
  }
};
